module.exports = __webpack_public_path__ + "static/media/19_r_stena_84.79_0.27a85b23.png";